module.exports = __webpack_public_path__ + "img/marketing-4-lock.0ce556b3.svg";